import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { useApi } from '@fortem-monorepo/react-spa'
import { Shareclasses } from '@fortem-monorepo/web-sdk'

export const useAddShareclassMutation = () => {
  const api = useApi()

  return useMutation({
    mutationFn: (body: Shareclasses.CreateShareclassBody) => {
      return api.shareclasses.create(body)
    },
    onSuccess: (_data, _params) => {
      toast.success('Shareclass created')
    },
  })
}
